import {
  diaQuoteResultsStrategy,
  diaQuoteResultsStrategyWithoutFilters,
} from "./diaQuoteResults.strategy";
import {
  iptQuoteResultsStrategy,
  iptQuoteResultsStrategyWithoutFilters,
} from "./iptQuoteResults.strategy";
import {
  biaQuoteResultsStrategy,
  biaQuoteResultsStrategyWithoutFilters,
} from "./biaQuoteResults.strategy";
import {
  wiaQuoteResultsStrategy,
  wiaQuoteResultsStrategyWithoutFilters,
} from "./wiaQuoteResults.strategy";
import {
  ipAddressQuoteResultsStrategy,
  ipAddressQuoteResultsStrategyWithoutFilters,
} from "./ipAddressQuoteResults.strategy";
import {
  eplQuoteResultsStrategy,
  eplQuoteResultsStrategyWithoutFilters,
} from "./eplQuoteResults.strategy";
import {
  hardwareQuoteResultsStrategy,
  hardwareQuoteResultsStrategyWithoutFilters,
} from "./hardwareQuoteResults.strategy";
import {
  fieldServiceQuoteResultsStrategy,
  fieldServiceQuoteResultsStrategyWithoutFilters,
} from "./fieldServiceQuoteResults.strategy";
import {
  rackAndSpaceQuoteResultsStrategy,
  rackAndSpaceQuoteResultsStrategyWithoutFilters,
} from "./rackAndSpaceQuoteResults.strategy";
import {
  crossConnectQuoteResultsStrategy,
  crossConnectQuoteResultsStrategyWithoutFilters,
} from "./crossConnectQuoteResults.strategy";
import { QUOTES_TYPE } from "@/common/const/types/index.const";

const productsStrategy = {
  [QUOTES_TYPE[0]]: diaQuoteResultsStrategy,
  [QUOTES_TYPE[1]]: iptQuoteResultsStrategy,
  [QUOTES_TYPE[2]]: biaQuoteResultsStrategy,
  [QUOTES_TYPE[3]]: wiaQuoteResultsStrategy,
  [QUOTES_TYPE[4]]: ipAddressQuoteResultsStrategy,
  [QUOTES_TYPE[5]]: eplQuoteResultsStrategy,
  [QUOTES_TYPE[6]]: eplQuoteResultsStrategy,
  [QUOTES_TYPE[7]]: hardwareQuoteResultsStrategy,
  [QUOTES_TYPE[8]]: fieldServiceQuoteResultsStrategy,
  [QUOTES_TYPE[9]]: rackAndSpaceQuoteResultsStrategy,
  [QUOTES_TYPE[10]]: crossConnectQuoteResultsStrategy,
};
const productsStrategyWithoutFilters = {
  [QUOTES_TYPE[0]]: diaQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[1]]: iptQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[2]]: biaQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[3]]: wiaQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[4]]: ipAddressQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[5]]: eplQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[6]]: eplQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[7]]: hardwareQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[8]]: fieldServiceQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[9]]: rackAndSpaceQuoteResultsStrategyWithoutFilters,
  [QUOTES_TYPE[10]]: crossConnectQuoteResultsStrategyWithoutFilters,
};

export { productsStrategy, productsStrategyWithoutFilters };
